var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from 'react';
import Button from '@empiriecom/module-components/Button';
import { ElevationLevel } from '@empiriecom/module-components/Card';
import { FormattedMessage, useIntl } from 'react-intl';
import { NotificationProvider, useNotificationContext, } from '@empiriecom/module-components/Notification/NotificationProvider';
import styled, { css } from 'styled-components';
import Panel from '@empiriecom/module-components/Panel';
import { useMedia, ProvideMediaMatchers } from 'react-media-match';
import { Grid, Cell } from '@empiriecom/module-components/Grid';
import BasicInput from '@empiriecom/module-components/FormControls/Input/BasicInput';
import Textarea from '@empiriecom/module-components/FormControls/Textarea';
import { Label } from '@empiriecom/module-components';
import InputEmail from '../../FormControls/InputEmail';
import IntlProvider from './IntlProvider';
import useConfig from '../../hooks/useConfig';
import { StyledContentTop, StyledContentBottom, StyledContentBottomSuccess, StyledCard, StyledHeadline, StyledSubHeadline, StyledMandatory, StyledCheckmark, StyledTerms, StyledDateInput, } from './styles';
import submitForm from './helpers/handleSubmit';
import { validationRuleFirstName, validationRuleLastName, validationRuleStreet, validationRuleHousenumber, validationRulePostalcode, validationRuleCity, validationRuleCustomerId, } from './helpers/validationRules';
import { getFormatMessage, getFormattedMessage } from './helpers/messages';
import { MockDataSuccess } from './mockdata';
import ToggleButton from '../../ToggleButtonGroup/ToggleButton';
import ToggleButtonGroup from '../../ToggleButtonGroup';
var StyleBasic = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin: 0;\n  padding: 0 1rem;\n"], ["\n  width: 100%;\n  margin: 0;\n  padding: 0 1rem;\n"])));
var StyledPanel = styled(Panel)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  padding: 1.25rem 1rem;\n  background-color: ", ";\n"], ["\n  ", "\n  padding: 1.25rem 1rem;\n  background-color: ", ";\n"])), StyleBasic, function (_a) {
    var greyLight = _a.theme.greyLight;
    return greyLight.color.normal;
});
var StyledGrid = styled(Grid)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), function (_a) {
    var rowGap = _a.rowGap;
    return rowGap;
});
var StyledContentWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), StyleBasic);
var RateProtectionContent = function (_a) {
    var requiredFields = _a.requiredFields, rowGap = _a.rowGap, companyId = _a.companyId, forceSuccess = _a.forceSuccess;
    var config = useConfig();
    var isMobile = useMedia({ mobile: true, tablet: false, desktop: false });
    // stateFormFilledComplete
    var _b = useState(false), stateFormFilledComplete = _b[0], setStateFormFilledComplete = _b[1];
    // stateFormIsValid
    var _c = useState(false), stateFormIsValidCustomerId = _c[0], setStateFormIsValidCustomerId = _c[1];
    var _d = useState(false), stateFormIsValidFirstname = _d[0], setStateFormIsValidFirstname = _d[1];
    var _e = useState(false), stateFormIsValidLastname = _e[0], setStateFormIsValidLastname = _e[1];
    var _f = useState(false), stateFormIsValidStreet = _f[0], setStateFormIsValidStreet = _f[1];
    var _g = useState(false), stateFormIsValidHousenumber = _g[0], setStateFormIsValidHousenumber = _g[1];
    var _h = useState(false), stateFormIsValidPostalcode = _h[0], setStateFormIsValidPostalcode = _h[1];
    var _j = useState(false), stateFormIsValidCity = _j[0], setStateFormIsValidCity = _j[1];
    var _k = useState(false), stateFormIsValidEmail = _k[0], setStateFormIsValidEmail = _k[1];
    var _l = useState(false), stateFormIsValidTerms = _l[0], setStateFormIsValidTerms = _l[1];
    var _m = useState(), salutation = _m[0], setSalutation = _m[1];
    var handleSalutation = function (event, newSalutation) {
        setSalutation(newSalutation);
    };
    // statePostData
    var _o = useState({
        message: '',
        customerData: {
            firstName: '',
            lastName: '',
            customerId: '',
            street: '',
            housenumber: '',
            city: '',
            postalCode: '',
            emailAddress: '',
            dateOfBirth: '',
        },
    }), statePostData = _o[0], setStatePostData = _o[1];
    var _p = useState(function () {
        if (forceSuccess) {
            return MockDataSuccess;
        }
        return null;
    }), formSubmitResult = _p[0], setFormSubmitResult = _p[1];
    // prevents getting stuck at the last scroll position after the rerender
    useEffect(function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [formSubmitResult]);
    var finalizePostData = function () {
        var customerid = document.getElementById('customerid');
        var firstname = document.getElementById('firstname');
        var lastname = document.getElementById('lastname');
        var street = document.getElementById('street');
        var housenumber = document.getElementById('housenumber');
        var city = document.getElementById('city');
        var postalCode = document.getElementById('postalcode');
        var email = document.getElementById('email');
        var birthday = document.getElementById('birthday');
        var message = document.getElementById('message');
        var finalPostData = __assign(__assign({}, statePostData), {
            customerData: __assign(__assign({ firstName: (firstname === null || firstname === void 0 ? void 0 : firstname.value) || '', lastName: (lastname === null || lastname === void 0 ? void 0 : lastname.value) || '', customerId: (customerid === null || customerid === void 0 ? void 0 : customerid.value) || '', street: (street === null || street === void 0 ? void 0 : street.value) || '', housenumber: (housenumber === null || housenumber === void 0 ? void 0 : housenumber.value) || '', city: (city === null || city === void 0 ? void 0 : city.value) || '', postalCode: postalCode.value || '', emailAddress: (email === null || email === void 0 ? void 0 : email.value) || '' }, (salutation && { salutation: salutation })), { dateOfBirth: (birthday === null || birthday === void 0 ? void 0 : birthday.value) || '' }),
            message: (message === null || message === void 0 ? void 0 : message.value) || '',
        });
        return finalPostData;
    };
    var handleFormCheck = function () {
        var formFieldComplete = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.every(function (item) {
            var tmpField = item ? document.getElementById(item) : null;
            return (tmpField === null || tmpField === void 0 ? void 0 : tmpField.value) !== '';
        });
        setStateFormFilledComplete(formFieldComplete);
        setStatePostData(finalizePostData());
    };
    var intl = useIntl();
    var FormButton = function () {
        var pushNotification = useNotificationContext().pushNotification;
        return (React.createElement(Button, { "data-testid": "button-submit", id: "button-submit", form: "rsv-form", layout: "primary", size: "large", fullWidth: isMobile, onClick: function (event) {
                event.preventDefault();
                submitForm({ setFormSubmitResult: setFormSubmitResult, pushNotification: pushNotification }, intl, config, finalizePostData());
            } },
            React.createElement(FormattedMessage, { id: "form.submit", defaultMessage: "" })));
    };
    return !formSubmitResult ? (React.createElement(React.Fragment, null,
        React.createElement(StyledPanel, null,
            React.createElement(StyledCard, { elevationLevel: ElevationLevel['1dp'], showOverflow: true },
                React.createElement("form", { onSubmit: function (event) {
                        event.preventDefault();
                    }, "data-testid": "rsv-form", id: "rsv-form" },
                    React.createElement(ProvideMediaMatchers, null,
                        React.createElement(StyledGrid, { cellsPerRow: [1, 2, 2], rowGap: rowGap, colGap: "2rem" },
                            React.createElement(Cell, null,
                                React.createElement(BasicInput, { id: "customerid", name: "customerid", label: getFormattedMessage('form.type.customernumber.label'), validationRules: validationRuleCustomerId, onChange: handleFormCheck, onError: function () {
                                        setStateFormIsValidCustomerId(false);
                                    }, onValid: function () {
                                        setStateFormIsValidCustomerId(true);
                                    } })),
                            React.createElement(Cell, null,
                                React.createElement(Label, { htmlFor: "salutationSelect" },
                                    React.createElement(FormattedMessage, { id: "form.type.salutation.label" })),
                                React.createElement(ToggleButtonGroup, { id: "salutationSelect", name: "salutationSelect", value: salutation, onChange: handleSalutation },
                                    React.createElement(ToggleButton, { value: "female", selected: salutation === 'female' },
                                        React.createElement(FormattedMessage, { id: "form.type.salutation.female" })),
                                    React.createElement(ToggleButton, { value: "male", selected: salutation === 'male' },
                                        React.createElement(FormattedMessage, { id: "form.type.salutation.male" }))))),
                        React.createElement(StyledGrid, { cellsPerRow: [1, 2, 2], rowGap: rowGap, colGap: "2rem" },
                            React.createElement(Cell, null,
                                React.createElement(BasicInput, { id: "firstname", name: "firstname", label: getFormattedMessage('form.type.firstname.label'), validationRules: validationRuleFirstName, onChange: handleFormCheck, onError: function () {
                                        setStateFormIsValidFirstname(false);
                                    }, onValid: function () {
                                        setStateFormIsValidFirstname(true);
                                    } })),
                            React.createElement(Cell, null,
                                React.createElement(BasicInput, { id: "lastname", name: "lastname", label: getFormattedMessage('form.type.lastname.label'), validationRules: validationRuleLastName, onChange: handleFormCheck, onError: function () {
                                        setStateFormIsValidLastname(false);
                                    }, onValid: function () {
                                        setStateFormIsValidLastname(true);
                                    } })),
                            React.createElement(Cell, null,
                                React.createElement(Grid, { fractionsPerRow: {
                                        mobile: ['1fr 5rem'],
                                        tablet: ['1fr 5rem'],
                                        desktop: ['1fr 5rem'],
                                    }, colGap: "1rem" },
                                    React.createElement(Cell, null,
                                        React.createElement(BasicInput, { id: "street", name: "street", label: getFormattedMessage('form.type.street.label'), validationRules: validationRuleStreet, onChange: handleFormCheck, onError: function () {
                                                setStateFormIsValidStreet(false);
                                            }, onValid: function () {
                                                setStateFormIsValidStreet(true);
                                            } })),
                                    React.createElement(Cell, null,
                                        React.createElement(BasicInput, { id: "housenumber", name: "housenumber", label: getFormattedMessage('form.type.housenumber.label'), validationRules: validationRuleHousenumber, onChange: handleFormCheck, onError: function () {
                                                setStateFormIsValidHousenumber(false);
                                            }, onValid: function () {
                                                setStateFormIsValidHousenumber(true);
                                            } })))),
                            React.createElement(Cell, null,
                                React.createElement(Grid, { fractionsPerRow: {
                                        mobile: ['8rem 1fr'],
                                        tablet: ['8rem 1fr'],
                                        desktop: ['8rem 1fr'],
                                    }, cellsPerRow: [2], colGap: "1rem" },
                                    React.createElement(Cell, null,
                                        React.createElement(BasicInput, { id: "postalcode", name: "postalcode", label: getFormattedMessage('form.type.postalcode.label'), type: "number", validationRules: validationRulePostalcode, onChange: handleFormCheck, onError: function () {
                                                setStateFormIsValidPostalcode(false);
                                            }, onValid: function () {
                                                setStateFormIsValidPostalcode(true);
                                            } })),
                                    React.createElement(Cell, null,
                                        React.createElement(BasicInput, { id: "city", name: "city", label: getFormattedMessage('form.type.city.label'), validationRules: validationRuleCity, onChange: handleFormCheck, onError: function () {
                                                setStateFormIsValidCity(false);
                                            }, onValid: function () {
                                                setStateFormIsValidCity(true);
                                            } })))),
                            React.createElement(Cell, null,
                                React.createElement(InputEmail, { companyId: companyId, id: "email", onChange: handleFormCheck, onError: function () {
                                        setStateFormIsValidEmail(false);
                                    }, onValid: function () {
                                        setStateFormIsValidEmail(true);
                                    } })),
                            React.createElement(Cell, null,
                                React.createElement(StyledDateInput, { id: "birthday", name: "birthday", type: "date", label: getFormattedMessage('form.type.birthday.label') }))),
                        React.createElement(StyledGrid, { cellsPerRow: [1], rowGap: rowGap, colGap: "2rem" },
                            React.createElement(Cell, null,
                                React.createElement(Textarea, { id: "message", label: getFormattedMessage('form.type.message.label'), placeholder: getFormatMessage('form.type.message.placeholder', intl), onChange: handleFormCheck }))),
                        React.createElement(StyledGrid, { cellsPerRow: [1], rowGap: rowGap, colGap: "2rem" },
                            React.createElement(Cell, null,
                                React.createElement("input", { id: "checkterms", type: "checkbox", "data-testid": "checkterms", onChange: function (event) { return setStateFormIsValidTerms(event.target.checked); } }),
                                ' ',
                                React.createElement(StyledTerms, { htmlFor: "checkterms", 
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML: { __html: getFormatMessage('form.type.terms', intl) } }))))))),
        React.createElement(StyledContentWrapper, null,
            React.createElement(StyledContentBottom, null,
                stateFormFilledComplete &&
                    stateFormIsValidCustomerId &&
                    stateFormIsValidFirstname &&
                    stateFormIsValidLastname &&
                    stateFormIsValidStreet &&
                    stateFormIsValidHousenumber &&
                    stateFormIsValidPostalcode &&
                    stateFormIsValidCity &&
                    stateFormIsValidTerms &&
                    stateFormIsValidEmail ? (React.createElement(FormButton, null)) : (React.createElement(Button, { "data-testid": "button-submit-disabled", id: "button-submit-disabled", form: "rsv-form", layout: "primary", size: "large", fullWidth: isMobile, disabled: true },
                    React.createElement(FormattedMessage, { id: "form.submit.info", defaultMessage: "" }))),
                React.createElement(StyledMandatory, null,
                    React.createElement(FormattedMessage, { id: "form.mandatory", defaultMessage: "" })))))) : (React.createElement(React.Fragment, null,
        React.createElement(StyledContentTop, null,
            React.createElement(StyledCheckmark, { size: "5rem" }),
            React.createElement(StyledHeadline, null,
                React.createElement(FormattedMessage, { id: "success.headline" })),
            React.createElement(StyledSubHeadline, null,
                React.createElement(FormattedMessage, { id: "success.description" }))),
        React.createElement(StyledContentBottomSuccess, null,
            React.createElement(Button, { asLink: true, to: "/", "data-testid": "button-success", id: "button-success", form: "rsv-form", layout: "default", size: "large" },
                React.createElement(FormattedMessage, { id: "back.to.shop", defaultMessage: "" })))));
};
var RateProtection = function (_a) {
    var companyId = _a.companyId, _b = _a.forceSuccess, forceSuccess = _b === void 0 ? false : _b, _c = _a.requiredFields, requiredFields = _c === void 0 ? [
        'customerid',
        'firstname',
        'lastname',
        'street',
        'housenumber',
        'city',
        'postalcode',
        'email',
    ] : _c, _d = _a.rowGap, rowGap = _d === void 0 ? '1.25rem' : _d;
    return (React.createElement(IntlProvider, { companyId: companyId },
        React.createElement(NotificationProvider, null,
            React.createElement(RateProtectionContent, { requiredFields: requiredFields, rowGap: rowGap, companyId: companyId, forceSuccess: forceSuccess }))));
};
export default RateProtection;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map